<template>
<div id="exportList">
    <div class="content">
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/export/setup`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-data-table
                    :headers="headers"
                    :items="exports"
                    :pagination.sync="pagination"
                    class="elevation-1 fixed-header"                                              
                    
                >
                    <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0" width="100px">
                            <v-icon small class="mr-2 pt-3" @click="retriveTemplate(props.item.id)">info</v-icon>
                            <v-icon small class="pt-3" @click="deleteExport(props.item, props.item.id, props.item.name)">delete</v-icon>
                        </td>
                        <td class="text-xs-left">{{ props.item.name }}</td>
                        <td class="text-xs-left">{{ props.item.filetype }}</td>
                        <td class="text-xs-left">{{ props.item.delimeter }}</td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table>                    
            </div>
        </div>
    </div>

    <v-dialog v-model="dialogTemplate" max-width="800px">
        <v-card>
            <table class="table">
                <thead class="thead-primary">
                    <tr>
                        <th>Name</th>
                        <th>Required</th>
                        <th>Sequence</th>
                        <th>Format</th>
                        <th>Char</th>
                        <th>In / Out Indicator</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in template" :key="index">
                        <td>{{ item.row_name }}</td>
                        <td>{{ item.required | toggleYN }}</td>
                        <td>{{ item.sequence }}</td>
                        <td>{{ item.type_format }}</td>
                        <td>{{ item.no_char}}</td>
                        <td>{{ item.in_out_inc}}</td>
                    </tr>
                </tbody>
            </table>
        </v-card>
        <v-card-actions class="justify-center">
            <v-btn @click="dialogTemplate = false">CLOSE</v-btn>
        </v-card-actions>
    </v-dialog>


</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

import { enableToggle, yesNoToggle, checkNullVal } from '../common/toggle.js'

export default {
    data () {
        return {
            title: 'EXPORT SETUP LISTING',
            headers: [
                    { text: 'ACTION', sortable: false, value: 'action' },
                    { text: 'NAME', value: 'name' },
                    { text: 'FILE TYPE', value: 'filetype' },
                    { text: 'DELIMETER', value: 'delimeter' },
            ],           
            exports: [],
            template: [],
            dialogTemplate: false,
            pagination: {'sortBy': 'name', 'descending': true, 'rowPerPage': -1},
        }
    },

    methods: {
        loadExports() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/export/template/list')
            .then(function (response) {
                vm.exports = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error;
            })
        },

        retriveTemplate(template_id) {
            let vm = this

            axios.get(this.$store.getters.rootAPI + '/export/template_detail/' + template_id)
                .then(function (response) {
                    vm.template = response.data.rec;
                    vm.dialogTemplate = !vm.dialogTemplate;

                })
                .catch(function (error) {
                    vm.status = 'An error occured.' + error;
                })
        },

        deleteExport(item, id, name) {
            var vm = this
            const index = vm.exports.indexOf(item)

            if(confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/export/template/' + id)
                .then(function (response) {
                        if (response.data.status === "error") {
                            alert("Cannot delete export " + name + " because it is in used!")
                        } else {
                            vm.exports.splice(index, 1)
                        }                        
                    })
                .catch(function (error) {
                    alert('An error occured.')
                    console.log(error)
                })
            }

        },

        redirectTo(path) {
            this.$router.push(path)
        },
    },

    created() {
        this.loadExports();
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/export/ExportList.vue